<template>
    <div class="max-w-full md:max-w-screen-md mx-auto bg-white py-16">
        <form
            action="/order"
            method="post"
            @submit.prevent="submit"
            v-if="!success"
        >
            <section class="step-1 mb-16 px-3" :class="{ hidden: step !== 1 }">
                <div class="mb-4">
                    <h2
                        class="text-brand-primary text-center text-2xl lg:text-3xl mb-6"
                    >
                        CHOOSE A WILDCARD
                    </h2>
                    <div
                        class="grid grid-cols-1 sm:grid-cols-2 col-gap-5 row-gap-5 mb-1"
                    >
                        <div
                            class="w-11/12 mx-auto relative wildcard-entry"
                            v-for="card in wild_cards"
                            :key="card.id"
                        >
                            <div
                                class="m-px rounded inline-block transition-shadow ease-linear duration-200 w-full"
                                :class="{
                                    'border-brand-primary':
                                        form.wild_card_id === card.id
                                }"
                            >
                                <!-- <input
                                    type="radio"
                                    name="wild_card"
                                    :id="card.id"
                                    v-model="form.wild_card_id"
                                    :value="card.id"
                                    class="hidden"
                                    @click.prevent="slectWildcard(card.id)"
                                /> -->
                                <div
                                    class="rounded bg-no-repeat bg-contain w-full min-h-full bg-center hover:shadow-outline"
                                    :style="
                                        `background-image: url('/storage/${card.image_url}'); padding-top: 100%;`
                                    "
                                ></div>
                                <!-- <img
                                    :src="'/storage/' + card.image_url"
                                    :alt="card.title"
                                /> -->
                            </div>
                            <div
                                class="flex absolute w-full share-buttons invisible"
                                style="bottom: 1rem;"
                            >
                                <a
                                    href="#"
                                    name="wild_card"
                                    class="flex-1 btn bg-brand-primary text-white mx-2 md:text-lg md:px-4 md:py-3"
                                    @click.prevent="
                                        slectWildcard(card.id, 'whatsapp')
                                    "
                                >
                                    <svg
                                        class="mx-auto"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ffffff"
                                    >
                                        <path
                                            d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
                                        />
                                    </svg>
                                </a>
                                <a
                                    href="#"
                                    name="wild_card"
                                    class="flex-1 btn bg-brand-primary text-white mx-2 md:text-lg md:px-4 md:py-3"
                                    @click.prevent="
                                        slectWildcard(card.id, 'email')
                                    "
                                >
                                    <svg
                                        class="mx-auto"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ffffff"
                                    >
                                        <path
                                            d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z"
                                        />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        class="feedback invalid"
                        role="alert"
                        v-if="errors.wild_card_id"
                    >
                        <p>
                            {{ errors.wild_card_id }}
                        </p>
                    </div>
                </div>
            </section>

            <section
                class="step-2 overflow-hidden px-1"
                :class="{ hidden: step !== 2 }"
            >
                <div>
                    <h2
                        class="text-center text-2xl lg:text-3xl mb-6 tracking-wide"
                        :class="{
                            'lg:-mb-8': form.recipients.length >= 2,
                            'lg:-mb-20': form.recipients.length >= 3
                        }"
                    >
                        I AM SENDING...
                    </h2>
                </div>

                <div
                    class="md:max-w-screen-md mx-auto relative bg-center p-3 sm:p-6 md:p-12 pb-0 sm:pb-0 md:pb-0 border-2 lg:border-3 border-b-0 lg:border-b-0 border-black bg-white lg:mt-32"
                    style="margin-left: 5.55%; margin-right: 5.6%; z-index: 1; margin-bottom: -40%; min-height: 200px;"
                >
                    <!-- Recipients -->
                    <div
                        class="recipient max-w-screen-md text-sm sm:text-base"
                        style=""
                    >
                        <h3 class="">
                            To<span v-if="form.recipients.length >= 2">
                                multiple recipients</span
                            >:
                        </h3>
                        <div
                            class="bg-white mb-4 relative"
                            v-for="(recipient, index) in form.recipients"
                            :key="index"
                        >
                            <div class="flex flex-wrap text-sm">
                                <div class="w-full flex flex-wrap">
                                    <div class="flex-1 mr-2">
                                        <label
                                            :for="`recipient_${index + 1}_name`"
                                            class="label-control"
                                            >Name</label
                                        >
                                        <input
                                            :id="`recipient_${index + 1}_name`"
                                            type="text"
                                            class="form-control"
                                            value=""
                                            :name="
                                                `recipient_${index + 1}_name`
                                            "
                                            :placeholder="
                                                `Recipient ${index + 1} name *`
                                            "
                                            v-model="recipient.name"
                                            :class="{
                                                'is-invalid':
                                                    errors[
                                                        `recipients.${index}.name`
                                                    ]
                                            }"
                                            @change="
                                                delete errors[
                                                    `recipients.${index}.name`
                                                ]
                                            "
                                            :ref="`recipient_${index + 1}_name`"
                                        />
                                        <span
                                            class="feedback invalid"
                                            role="alert"
                                            v-if="
                                                errors[
                                                    `recipients.${index}.name`
                                                ]
                                            "
                                        >
                                            <strong>{{
                                                errors[
                                                    `recipients.${index}.name`
                                                ]
                                            }}</strong>
                                        </span>
                                    </div>

                                    <div class="flex-1 ml-2">
                                        <label
                                            :for="
                                                `recipient_${index + 1}_email`
                                            "
                                            class="label-control"
                                            >Email *</label
                                        >
                                        <input
                                            :id="`recipient_${index + 1}_email`"
                                            type="text"
                                            class="form-control"
                                            value=""
                                            name="recipient_1_email"
                                            :placeholder="
                                                `Recipient ${index + 1} email *`
                                            "
                                            v-model="recipient.email"
                                            :class="{
                                                'is-invalid':
                                                    errors[
                                                        `recipients.${index}.email`
                                                    ]
                                            }"
                                            @change="
                                                delete errors[
                                                    `recipients.${index}.email`
                                                ]
                                            "
                                        />
                                        <span
                                            class="feedback invalid"
                                            role="alert"
                                            v-if="
                                                errors[
                                                    `recipients.${index}.email`
                                                ]
                                            "
                                        >
                                            <strong>{{
                                                errors[
                                                    `recipients.${index}.email`
                                                ]
                                            }}</strong>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full text-sm">
                                <label
                                    :for="`recipient_${index + 1}_message`"
                                    class="label-control"
                                    >Message *</label
                                >
                                <textarea
                                    :id="`recipient_${index + 1}_message`"
                                    class="form-control"
                                    name="recipient_message"
                                    cols="20"
                                    rows="1"
                                    maxlength="120"
                                    v-model="recipient.message"
                                    :placeholder="
                                        `Your personal message for recipient ${index +
                                            1} (max. 120 characters)`
                                    "
                                    :class="{
                                        'is-invalid':
                                            errors[
                                                `recipients.${index}.message`
                                            ]
                                    }"
                                    @change="
                                        delete errors[
                                            `recipients.${index}.message`
                                        ]
                                    "
                                ></textarea>
                                <span
                                    class="feedback invalid"
                                    role="alert"
                                    v-if="errors[`recipients.${index}.message`]"
                                >
                                    <strong>{{
                                        errors[`recipients.${index}.message`]
                                    }}</strong>
                                </span>
                            </div>

                            <div
                                class="absolute top-0 right-0 w-1 h-1 font-mono bg-white border border-gray-600 text-gray-600 hover:border-black hover:text-black text-center cursor-pointer"
                                style="top: 22px; right: -30px; width: 16px; height: 16px; line-height: 13px;"
                                v-if="form.recipients.length >= 2"
                                @click.prevent="
                                    form.recipients.splice(index, 1)
                                "
                            >
                                x
                            </div>
                        </div>
                        <a
                            href="#"
                            class="text-xs p-2 bg-brand-primary rounded-md text-white px-2 py-1 outline-none"
                            v-if="
                                form.send_type == 'email' &&
                                    form.recipients.length < 10
                            "
                            @click.prevent="add_recipient"
                            tabindex="-1"
                        >
                            + Add 1 more recipient
                        </a>
                    </div>

                    <div
                        class="sender mt-6 lg:absolute lg:left-0 lg:border-2 lg:border-black bg-white lg:p-3 lg:max-w-xs"
                        style="bottom: -520px;"
                    >
                        <h3 class="">From:</h3>
                        <div class="flex flex-wrap text-sm">
                            <div class="flex-1 mr-4">
                                <label class="label-control">
                                    First name *
                                </label>
                                <input
                                    id="sender_first_name"
                                    type="text"
                                    class="form-control"
                                    value=""
                                    name="sender_first_name"
                                    placeholder="First name *"
                                    v-model="form.sender_first_name"
                                    v-bind:class="{
                                        'is-invalid': errors.sender_first_name
                                    }"
                                />
                                <span
                                    class="feedback invalid"
                                    role="alert"
                                    v-if="errors.sender_first_name"
                                >
                                    <strong>{{
                                        errors.sender_first_name
                                    }}</strong>
                                </span>
                            </div>
                            <div class="flex-1">
                                <label class="label-control">
                                    Last name
                                </label>
                                <input
                                    id="sender_last_name"
                                    type="text"
                                    class="form-control"
                                    value=""
                                    name="sender_last_name"
                                    placeholder="Last name *"
                                    v-model="form.sender_last_name"
                                    v-bind:class="{
                                        'is-invalid': errors.sender_last_name
                                    }"
                                />
                                <span
                                    class="feedback invalid"
                                    role="alert"
                                    v-if="errors.sender_last_name"
                                >
                                    <strong>{{
                                        errors.sender_last_name
                                    }}</strong>
                                </span>
                            </div>
                        </div>

                        <div class="flex flex-wrap text-sm">
                            <div class="w-full">
                                <label class="label-control">Email</label>
                                <input
                                    id="sender_email"
                                    type="text"
                                    class="form-control"
                                    value=""
                                    name="sender_email"
                                    placeholder="Email *"
                                    v-model="form.sender_email"
                                    v-bind:class="{
                                        'is-invalid': errors.sender_email
                                    }"
                                />
                                <span
                                    class="feedback invalid"
                                    role="alert"
                                    v-if="errors.sender_email"
                                >
                                    <strong>{{ errors.sender_email }}</strong>
                                </span>
                            </div>
                            <div class="w-full">
                                <label class="label-control">Mobile</label>
                                <input
                                    id="sender_mobile"
                                    type="text"
                                    class="form-control"
                                    value=""
                                    name="sender_mobile"
                                    placeholder="Phone number *"
                                    v-model="form.sender_mobile"
                                    v-bind:class="{
                                        'is-invalid': errors.sender_mobile
                                    }"
                                />
                                <span
                                    class="feedback invalid"
                                    role="alert"
                                    v-if="errors.sender_mobile"
                                >
                                    <strong>{{ errors.sender_mobile }}</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-8 relative bottom-0 left-0">
                    <div class="overflow-x-hidden">
                        <img
                            class="w-full h-auto"
                            src="/imgs/letter.svg"
                            alt=""
                        />
                        <div
                            class="w-1/2 md:w-2/5 max-w-screen-sm absolute right-0 bottom-0 transform rotate-6 mt-48"
                            style="right: 7%;"
                        >
                            <div
                                v-if="selectedWildCardImage.length"
                                class="z-20 bg-no-repeat bg-contain bg-center max-w-full"
                                :style="
                                    `background-image: url('/storage/${selectedWildCardImage[0].image_url}'); width: 300px; height: 300px;`
                                "
                            ></div>
                        </div>
                    </div>

                    <div>
                        <svg
                            class="absolute"
                            style="left: -1%; top: 40%; width: 20%"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 120.264 133.692"
                        >
                            <g
                                id="Group_255"
                                data-name="Group 255"
                                transform="matrix(0.978, 0.208, -0.208, 0.978, -165.005, -620.107)"
                            >
                                <g
                                    id="Group_31"
                                    data-name="Group 31"
                                    transform="translate(1115.887 713.865) rotate(128)"
                                >
                                    <path
                                        id="Path_15132"
                                        data-name="Path 15132"
                                        d="M360.146,698.635a4.662,4.662,0,0,1,1.512-3.425,33.38,33.38,0,0,0,4.731-5.109,11.027,11.027,0,0,0,2.12.21c4.383,0,8.812-2.475,12.758-5.16a63.485,63.485,0,0,1-6.432.4,28.574,28.574,0,0,1-5.393-.479c3.627-7.518,3.881-15.646,4.773-23.709a28.056,28.056,0,0,0,14.406-8.825,22.75,22.75,0,0,1-6.609.972,23.022,23.022,0,0,1-6.379-.9c2.038-8.549,6.521-16.727,18.511-23.68,2.5-1.459,5.026-3.164,7.613-4.521.094-.051.189-.1.283-.145.112.066.213.131.313.2,7.336,5.036,12.77,13.382,16.113,22.17a35.948,35.948,0,0,0-7.212-1.9A59.56,59.56,0,0,1,421.6,657.931a49.846,49.846,0,0,1,.792,8.52c0,14.311-8.263,29.978-26.006,36.938a59.131,59.131,0,0,0,1.022-10.7c0-.334,0-.675-.006-1.016a31.964,31.964,0,0,1-6.143,13.4,60.6,60.6,0,0,1-15.954,2.01C368.291,707.082,360.146,702.423,360.146,698.635Z"
                                        transform="translate(0 0.006)"
                                        fill="#85c065"
                                    />
                                    <g
                                        id="Group_29"
                                        data-name="Group 29"
                                        transform="translate(369.908 624.266)"
                                    >
                                        <path
                                            id="Path_15133"
                                            data-name="Path 15133"
                                            d="M466.034,649.678c1.767,31.154-5.855,67.163-32.5,74.92l.14.717c26.984-7.846,34.728-44.142,32.973-75.577-.1-.074-.207-.14-.311-.214C466.326,649.531,466.034,649.678,466.034,649.678Z"
                                            transform="translate(-433.536 -649.523)"
                                            fill="#23674f"
                                        />
                                    </g>
                                </g>
                                <g
                                    id="Group_75"
                                    data-name="Group 75"
                                    transform="matrix(0.978, -0.208, 0.208, 0.978, 341.369, 568.636)"
                                >
                                    <g id="Group_69" data-name="Group 69">
                                        <path
                                            id="Path_15161"
                                            data-name="Path 15161"
                                            d="M1036.715,680.646c-18.751,3.993-52.2,7.5-52.2,42.339,0,14.891,6.682,28.484,22.5,28.484,10.655,0,36.153-6.076,36.153-35.288C1043.164,703.992,1039.891,692.341,1036.715,680.646Z"
                                            transform="translate(-984.515 -680.646)"
                                            fill="#85c065"
                                        />
                                    </g>
                                    <path
                                        id="Path_15162"
                                        data-name="Path 15162"
                                        d="M1044.828,743.924l-.109-.518-30.377,6.37,6.058-9.735,27.643-5.8-.109-.518-27.147,5.693,6.057-9.734,21.146-4.434-.109-.518-20.65,4.33,6.058-9.735,13.82-2.9-.109-.518-13.325,2.794,8.931-14.352-.45-.28-8.8,14.135-3.22-12.85-.514.129,3.344,13.347-6.088,9.784-5.061-20.2-.514.129,5.186,20.695-6.088,9.784-6.7-26.726-.514.129,6.821,27.223-6.089,9.784-7.521-30.014-.514.128,7.645,30.511-6.089,9.785-6.732-26.866-.514.128,6.856,27.363-1.816,2.919.449.28,1.815-2.917,27.608-5.79-.109-.518-27.112,5.686,6.058-9.735Z"
                                        transform="translate(-994.853 -696.082)"
                                        fill="#23674f"
                                    />
                                </g>
                                <g
                                    id="Group_77"
                                    data-name="Group 77"
                                    transform="translate(397.047 615.483) rotate(31)"
                                >
                                    <g
                                        id="Group_71"
                                        data-name="Group 71"
                                        transform="translate(0 0)"
                                    >
                                        <path
                                            id="Path_15163"
                                            data-name="Path 15163"
                                            d="M1205.432,694.082c-10,9.258-13.878,23.413-13.878,36.8,0,16.815,10.176,26.141,19.355,26.141,11.262,0,14.642-12.493,14.642-23.491C1225.551,718.056,1216.727,704.213,1205.432,694.082Z"
                                            transform="translate(-1191.554 -694.082)"
                                            fill="#53a670"
                                        />
                                    </g>
                                    <path
                                        id="Path_15164"
                                        data-name="Path 15164"
                                        d="M1230.834,750.452l-.448-.229-8.75,17.081-.944-11.149,9.209-17.976-.449-.229-8.841,17.258-.944-11.149,7.231-14.115-.448-.23-6.863,13.4-.944-11.149,4.467-8.72-.448-.23-4.1,8-.851-10.049-.5.042.859,10.152-5.471-7.286-.4.3,5.938,7.908c.013-.01.957,11.14.957,11.14l-9.089-12.1-.4.3,9.571,12.745.942,11.119-11.67-15.54-.4.3,12.152,16.181.942,11.119L1209.608,752l-.4.3,12.008,15.991.586,6.914.5-.042-.585-6.913Z"
                                        transform="translate(-1202.696 -712.25)"
                                        fill="#23674f"
                                    />
                                </g>
                            </g>
                        </svg>

                        <svg
                            class="absolute"
                            style="right: 0%; top: 85%; width: 12%"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 131.451 174.572"
                        >
                            <g
                                id="Group_247"
                                data-name="Group 247"
                                transform="translate(-892.143 -715.851) rotate(3)"
                            >
                                <g
                                    id="Group_30"
                                    data-name="Group 30"
                                    transform="translate(829.824 -35.134) rotate(16)"
                                >
                                    <path
                                        id="Path_15132"
                                        data-name="Path 15132"
                                        d="M419.145,630.783a3.337,3.337,0,0,1-1.433,2.643,28.749,28.749,0,0,0-4.485,3.941,12.773,12.773,0,0,0-2.01-.162c-4.154,0-8.353,1.909-12.093,3.981,2.021-.168,4.065-.308,6.1-.308a33.118,33.118,0,0,1,5.112.369c-3.438,5.8-3.678,12.071-4.524,18.291a28.149,28.149,0,0,0-13.655,6.808,26.166,26.166,0,0,1,6.265-.75,26.5,26.5,0,0,1,6.047.694c-1.932,6.6-6.181,12.905-17.546,18.269-2.374,1.125-4.764,2.441-7.217,3.488-.09.039-.179.078-.269.112-.106-.051-.2-.1-.3-.157-6.954-3.885-12.1-10.324-15.273-17.1a40.453,40.453,0,0,0,6.836,1.467,48.814,48.814,0,0,1-9.8-10.178,31.532,31.532,0,0,1-.75-6.573c0-11.041,7.833-23.128,24.651-28.5a37.428,37.428,0,0,0-.969,8.252c0,.258,0,.521.006.784a22.888,22.888,0,0,1,5.823-10.335,69.891,69.891,0,0,1,15.122-1.551C411.424,624.266,419.145,627.86,419.145,630.783Z"
                                        fill="#85c065"
                                    />
                                    <g
                                        id="Group_29"
                                        data-name="Group 29"
                                        transform="translate(378.92 630.727)"
                                    >
                                        <path
                                            id="Path_15133"
                                            data-name="Path 15133"
                                            d="M434.318,706.842c-1.624-23.61,5.38-50.9,29.863-56.776l-.129-.543c-24.8,5.946-31.913,33.452-30.3,57.274.1.056.19.106.285.162Z"
                                            transform="translate(-433.536 -649.523)"
                                            fill="#23674f"
                                        />
                                    </g>
                                </g>
                                <g
                                    id="Group_73"
                                    data-name="Group 73"
                                    transform="matrix(0.53, -0.848, 0.848, 0.53, -166.089, 1227.509)"
                                >
                                    <gC
                                        id="Group_70"
                                        data-name="Group 70"
                                        transform="translate(984.515 680.646)"
                                    >
                                        <g id="Group_69" data-name="Group 69">
                                            <path
                                                id="Path_15161"
                                                data-name="Path 15161"
                                                d="M1036.715,680.646c-18.751,3.993-52.2,7.5-52.2,42.339,0,14.891,6.682,28.484,22.5,28.484,10.655,0,36.153-6.076,36.153-35.288C1043.164,703.992,1039.891,692.341,1036.715,680.646Z"
                                                transform="translate(-984.515 -680.646)"
                                                fill="#85c065"
                                            />
                                        </g>
                                        <path
                                            id="Path_15162"
                                            data-name="Path 15162"
                                            d="M1044.828,743.924l-.109-.518-30.377,6.37,6.058-9.735,27.643-5.8-.109-.518-27.147,5.693,6.057-9.734,21.146-4.434-.109-.518-20.65,4.33,6.058-9.735,13.82-2.9-.109-.518-13.325,2.794,8.931-14.352-.45-.28-8.8,14.135-3.22-12.85-.514.129,3.344,13.347-6.088,9.784-5.061-20.2-.514.129,5.186,20.695-6.088,9.784-6.7-26.726-.514.129,6.821,27.223-6.089,9.784-7.521-30.014-.514.128,7.645,30.511-6.089,9.785-6.732-26.866-.514.128,6.856,27.363-1.816,2.919.449.28,1.815-2.917,27.608-5.79-.109-.518-27.112,5.686,6.058-9.735Z"
                                            transform="translate(-994.853 -696.082)"
                                            fill="#23674f"
                                        />
                                    </g>
                                    <g
                                        id="Group_74"
                                        data-name="Group 74"
                                        transform="translate(984.515 680.646)"
                                    >
                                        <g id="Group_69-2" data-name="Group 69">
                                            <path
                                                id="Path_15161-2"
                                                data-name="Path 15161"
                                                d="M1036.715,680.646c-18.751,3.993-52.2,7.5-52.2,42.339,0,14.891,6.682,28.484,22.5,28.484,10.655,0,36.153-6.076,36.153-35.288C1043.164,703.992,1039.891,692.341,1036.715,680.646Z"
                                                transform="translate(-984.515 -680.646)"
                                                fill="#85c065"
                                            />
                                        </g>
                                        <path
                                            id="Path_15162-2"
                                            data-name="Path 15162"
                                            d="M1044.828,743.924l-.109-.518-30.377,6.37,6.058-9.735,27.643-5.8-.109-.518-27.147,5.693,6.057-9.734,21.146-4.434-.109-.518-20.65,4.33,6.058-9.735,13.82-2.9-.109-.518-13.325,2.794,8.931-14.352-.45-.28-8.8,14.135-3.22-12.85-.514.129,3.344,13.347-6.088,9.784-5.061-20.2-.514.129,5.186,20.695-6.088,9.784-6.7-26.726-.514.129,6.821,27.223-6.089,9.784-7.521-30.014-.514.128,7.645,30.511-6.089,9.785-6.732-26.866-.514.128,6.856,27.363-1.816,2.919.449.28,1.815-2.917,27.608-5.79-.109-.518-27.112,5.686,6.058-9.735Z"
                                            transform="translate(-994.853 -696.082)"
                                            fill="#23674f"
                                        />
                                    </g>
                                </g>
                                <g
                                    id="Group_76"
                                    data-name="Group 76"
                                    transform="matrix(0.883, -0.469, 0.469, 0.883, 986.82, 767.742)"
                                >
                                    <g
                                        id="Group_71"
                                        data-name="Group 71"
                                        transform="translate(0 0)"
                                    >
                                        <path
                                            id="Path_15163"
                                            data-name="Path 15163"
                                            d="M1209.094,694.082c-12.643,11.7-17.54,29.589-17.54,46.5,0,21.251,12.861,33.037,24.46,33.037,14.233,0,18.505-15.789,18.505-29.688C1234.52,724.381,1223.367,706.885,1209.094,694.082Z"
                                            transform="translate(-1191.554 -694.082)"
                                            fill="#53a670"
                                        />
                                    </g>
                                    <path
                                        id="Path_15164"
                                        data-name="Path 15164"
                                        d="M1236.846,758.231l-.567-.29-11.058,21.587-1.193-14.09,11.639-22.719-.567-.29-11.173,21.811-1.193-14.09,9.138-17.839-.567-.291-8.673,16.932-1.193-14.09,5.646-11.021-.567-.29-5.18,10.113-1.076-12.7-.634.053,1.086,12.83-6.915-9.208-.508.382,7.5,9.994c.016-.012,1.209,14.078,1.209,14.078l-11.486-15.3-.508.382,12.1,16.107,1.19,14.052L1208.549,744.7l-.508.382,15.357,20.45,1.19,14.052-14.567-19.4-.508.382,15.176,20.209.74,8.738.633-.053-.74-8.737Z"
                                        transform="translate(-1201.285 -709.95)"
                                        fill="#23674f"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>

                <div class="w-full mb-8 px-3 text-center">
                    <div class="flex justify-center items-baseline">
                        <input
                            type="checkbox"
                            name="pdpa_check"
                            id="pdpa_check"
                            class="custom-control-input mr-2 mt-2"
                            v-model="form.pdpa_check"
                            :checked="form.pdpa_check"
                            required
                        />
                        <label for="pdpa_check" class="">
                            I agree to WWF-Singapore's
                            <a
                                href="https://www.wwf.sg/wwf_singapore/pdp_policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="underline"
                                tabindex="-1"
                                >Personal Data Protection Policy.</a
                            >
                        </label>
                    </div>
                    <p
                        class="feedback invalid"
                        role="alert"
                        v-if="errors.pdpa_check"
                    >
                        <strong>You need to accept the terms to proceed</strong>
                    </p>
                    <!-- <div class="custom-control custom-checkbox mb-2 mt-4">
                        <input
                            type="checkbox"
                            name="updates_check"
                            id="updates_check"
                            class="custom-control-input"
                            v-model="form.updates_check"
                            :checked="form.updates_check"
                        />
                        <label for="updates_check" class="text-sm">
                            Subscribe to project updates and news via email
                        </label>
                    </div> -->
                </div>

                <div
                    v-if="form.send_type == 'whatsapp'"
                    id="send-whatsapp"
                    class="text-center mt-8 mb-16"
                >
                    <button
                        type="submit"
                        formaction="/order/whatsapp"
                        formmethod="POST"
                        :disabled="submitting"
                        class="btn bg-brand-primary text-white mx-3 md:text-lg md:px-4 md:py-3"
                    >
                        <span v-show="!submitting"
                            >SEND WILDCARD via WhatsApp!</span
                        >
                        <svg
                            width="200"
                            height="32"
                            class="loading mx-auto"
                            v-show="submitting"
                            version="1.1"
                            id="L4"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 70 100"
                            enable-background="new 0 0 0 0"
                            xml:space="preserve"
                        >
                            <circle
                                fill="#ffffff"
                                stroke="none"
                                cx="0"
                                cy="50"
                                r="8"
                            >
                                <animate
                                    attributeName="opacity"
                                    dur="1s"
                                    values="0;1;0"
                                    repeatCount="indefinite"
                                    begin="0.1"
                                />
                            </circle>
                            <circle
                                fill="#ffffff"
                                stroke="none"
                                cx="33"
                                cy="50"
                                r="8"
                            >
                                <animate
                                    attributeName="opacity"
                                    dur="1s"
                                    values="0;1;0"
                                    repeatCount="indefinite"
                                    begin="0.2"
                                />
                            </circle>
                            <circle
                                fill="#ffffff"
                                stroke="none"
                                cx="66"
                                cy="50"
                                r="8"
                            >
                                <animate
                                    attributeName="opacity"
                                    dur="1s"
                                    values="0;1;0"
                                    repeatCount="indefinite"
                                    begin="0.3"
                                />
                            </circle>
                        </svg>
                    </button>
                </div>

                <div v-if="form.send_type == 'email'" id="send-email">
                    <div
                        class="flex px-3 mb-4 justify-center text-lg md:text-xl"
                    >
                        <p class="text-lg mb-3">Send this card on:</p>
                        <div class="ml-4">
                            <date-picker
                                :value="1"
                                id="scheduled_at"
                                type="date"
                                name="scheduled_at"
                                v-model="form.scheduled_date"
                                :class="{
                                    'is-invalid': errors.scheduled_at
                                }"
                                mode="date"
                                title-position="left"
                                :model-config="{
                                    type: 'string',
                                    mask: 'YYYY-MM-DD'
                                }"
                                :min-date="new Date()"
                                :max-date="
                                    new Date(
                                        new Date().getFullYear() + 1,
                                        new Date().getMonth(),
                                        new Date().getDate()
                                    )
                                "
                                :masks="{
                                    input: 'DD/MM/YYYY'
                                }"
                                :popover="{
                                    placement: $screens({
                                        default: 'bottom-end'
                                    })
                                }"
                                placeholder="DD/MM/YYYY"
                            >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input
                                        id="date"
                                        class="bg-white w-full p-1 appearance-none focus:outline-none text-gray-700 border-b-2 border-gray-400 leading-tight"
                                        style="max-width: 120px"
                                        :value="inputValue"
                                        v-on="inputEvents"
                                    />
                                </template>
                            </date-picker>

                            <div class="w-full" style="max-width: 300px">
                                <span
                                    class="feedback invalid"
                                    role="alert"
                                    v-if="errors.scheduled_at"
                                >
                                    <strong>{{ errors.scheduled_at }}</strong>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="text-center mt-8 mb-16">
                        <button
                            type="submit"
                            :disabled="submitting"
                            class="btn bg-brand-primary text-white mx-3 md:text-lg md:px-4 md:py-3"
                        >
                            <span v-show="!submitting">SEND WILDCARD!</span>
                            <svg
                                width="200"
                                height="32"
                                class="loading mx-auto"
                                v-show="submitting"
                                version="1.1"
                                id="L4"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 70 100"
                                enable-background="new 0 0 0 0"
                                xml:space="preserve"
                            >
                                <circle
                                    fill="#ffffff"
                                    stroke="none"
                                    cx="0"
                                    cy="50"
                                    r="8"
                                >
                                    <animate
                                        attributeName="opacity"
                                        dur="1s"
                                        values="0;1;0"
                                        repeatCount="indefinite"
                                        begin="0.1"
                                    />
                                </circle>
                                <circle
                                    fill="#ffffff"
                                    stroke="none"
                                    cx="33"
                                    cy="50"
                                    r="8"
                                >
                                    <animate
                                        attributeName="opacity"
                                        dur="1s"
                                        values="0;1;0"
                                        repeatCount="indefinite"
                                        begin="0.2"
                                    />
                                </circle>
                                <circle
                                    fill="#ffffff"
                                    stroke="none"
                                    cx="66"
                                    cy="50"
                                    r="8"
                                >
                                    <animate
                                        attributeName="opacity"
                                        dur="1s"
                                        values="0;1;0"
                                        repeatCount="indefinite"
                                        begin="0.3"
                                    />
                                </circle>
                            </svg>
                        </button>
                    </div>
                </div>
            </section>
        </form>
        <div id="form_success" :ref="`form_success`">
            <div
                v-if="success"
                class="mb-16 text-center py-8 md:py-16 xl:py-32"
            >
                <p
                    v-if="!this.isScheduled"
                    class="text-brand-primary text-2xl mb-4 font-bold"
                >
                    SUCCESS!
                </p>
                <p v-else class="text-brand-primary text-2xl mb-4 font-bold">
                    SCHEDULED!
                </p>
                <svg
                    class="mb-4 mx-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="115"
                    height="110"
                    viewBox="0 0 115 110"
                >
                    <defs>
                        <pattern
                            id="pattern"
                            preserveAspectRatio="none"
                            width="100%"
                            height="100%"
                            viewBox="0 0 141 136"
                        >
                            <image
                                width="141"
                                height="136"
                                xlink:href="data:image/png;base64,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"
                            />
                        </pattern>
                    </defs>
                    <rect
                        id="Image_3"
                        data-name="Image 3"
                        width="115"
                        height="110"
                        fill="url(#pattern)"
                    />
                </svg>
                <p class="mb-4">Your card will be sent to:</p>
                <p
                    class="mb-4 font-weight-bold"
                    v-for="(recipient, index) in form.recipients"
                    :key="index"
                >
                    {{ recipient.name }}
                </p>
                <p v-if="this.isScheduled">
                    on {{ form.scheduled_date | date }}
                </p>
                <a
                    class="inline-block mb-4 bg-brand-primary hover:bg-brand-secondary text-white mt-6 py-2 px-4 rounded font-bold lg:text-lg"
                    href=""
                    >SEND ANOTHER CARD</a
                >
                <br />
                <a
                    class="border-2 border-brand-primary font-bold hover:bg-brand-secondary hover:text-white inline-block lg:text-lg mb-4 px-3 py-2 rounded text-black text-brand-primary"
                    :href="
                        `https://shop.wwf.sg/?utm_source=wildcards&utm_medium=org&utm_campaign=${occasion.slug}&utm_content=shop-gift`
                    "
                    >BUY A GIFT</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Singapore");
Vue.component("date-picker", DatePicker);

export default {
    props: {
        occasion: Object,
        wild_cards: Array,
        token_csrf: String
    },

    components: { DatePicker },

    data() {
        return {
            step: 1,
            form: {
                _token: this.token_csrf,
                occasion_id: this.occasion.id,
                send_type: "",
                wild_card_id: "",
                sender_first_name: "",
                sender_last_name: "",
                sender_email: "",
                sender_mobile: "",
                recipients: [
                    {
                        id: 0,
                        name: "",
                        email: "",
                        message: ""
                    }
                ],
                scheduled_date: moment().format("DD/MM/YYYY"),
                pdpa_check: false,
                updates_check: false
            },
            submitting: false,
            success: false,
            errors: {}
        };
    },

    filters: {
        date(date) {
            return moment(date).format("DD-MM-YYYY");
        }
    },

    methods: {
        submit() {
            this.submitting = true;
            let formData = this.form;
            formData.scheduled_at = this.scheduledDate;

            fetch("/order", {
                method: "post",
                body: JSON.stringify(this.form),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(data => data.json())
                .then(data => {
                    if (typeof data.errors != "undefined") {
                        this.submitting = false;
                        let firstKey = "";

                        Object.keys(data.errors).forEach(key => {
                            firstKey ? firstKey : key;
                            this.errors[key] = data.errors[key][0];
                        });

                        // @todo focus on first error field
                        // this.$nextTick(() => {
                        //     console.log();
                        //     this.$refs[this.errors[firstKey]][0].focus();
                        // });
                    } else {
                        if (data.status == "success") {
                            this.submitting = false;
                            this.success = true;

                            if (typeof dataLayer == "object") {
                                dataLayer.push({
                                    event: "purchase",
                                    ecommerce: {
                                        purchase: {
                                            transaction_id: data.txn
                                                ? data.txn
                                                : "",
                                            items: [
                                                {
                                                    item_name: this.wild_cards.find(
                                                        ele =>
                                                            ele.id ==
                                                            this.form
                                                                .wild_card_id
                                                    ).title,
                                                    item_id: this.form
                                                        .wild_card_id,
                                                    price: "0",
                                                    item_brand: this.occasion
                                                        .title,
                                                    item_category: this.occasion
                                                        .title,
                                                    item_category_2: "",
                                                    index: 1,
                                                    quantity: "1"
                                                }
                                            ]
                                        }
                                    }
                                });
                            }
                            // if (typeof gtag === "function") {
                            //     gtag("event", "purchase", {
                            //         transaction_id: data.txn ? data.txn : "",
                            //         items: [
                            //             {
                            //                 id: this.form.wild_card_id,
                            //                 name: this.wild_cards.find(
                            //                     ele =>
                            //                         ele.id ==
                            //                         this.form.wild_card_id
                            //                 ).title,
                            //                 brand: this.occasion.title,
                            //                 category: this.occasion.title
                            //             }
                            //         ]
                            //     });
                            // }

                            window.location.hash = "form_success";
                            window.scrollTo(0, 0);

                            this.sendSubscription(this.form);
                            console.log("Processing completed");
                        } else if (data.status == "redirect") {
                            window.location = data.url;
                        } else {
                            console.error("Processing failed");
                        }
                    }

                    this.submitting = false;
                })
                .catch(err => {
                    this.submitting = false;
                    console.log(err);
                });
        },
        submitWhatsApp() {
            this.submit();
        },
        add_recipient(e) {
            if (this.form.recipients.length >= 10) {
                this.$nextTick(() => {
                    this.$refs[
                        `recipient_${this.form.recipients.length}_name`
                    ][0].focus();
                });
                return this.form.recipients;
            }

            this.form.recipients.push({
                id: this.form.recipients.length,
                name: "",
                email: "",
                message: ""
            });

            Vue.set(this.form, "recipients", this.form.recipients);
            this.$nextTick(() => {
                this.$refs[
                    `recipient_${this.form.recipients.length}_name`
                ][0].focus();
            });

            return this.form.recipients;
        },
        slectWildcard(card_id = null, send_type = "email") {
            this.form.send_type = send_type;
            this.form.wild_card_id = card_id;
            this.step = 2;

            if (typeof dataLayer == "object") {
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: [
                            {
                                item_name: this.wild_cards.find(
                                    ele => ele.id == this.form.wild_card_id
                                ).title,
                                item_id: this.form.wild_card_id,
                                price: "0",
                                item_brand: this.occasion.title,
                                item_category: this.occasion.title,
                                item_category_2: "",
                                index: 1,
                                quantity: "1"
                            }
                        ]
                    }
                });
            }
            // if (typeof gtag === "function") {
            //     gtag("event", "add_to_cart", {
            //         items: [
            //             {
            //                 id: this.form.wild_card_id,
            //                 name: this.wild_cards.find(
            //                     ele => ele.id == this.form.wild_card_id
            //                 ).title,
            //                 brand: this.occasion.title,
            //                 category: this.occasion.title
            //             }
            //         ]
            //     });
            // }

            this.$nextTick(() => {
                this.$refs[`recipient_1_name`][0].focus();
            });
        },
        sendSubscription(form, callback = () => {}) {
            let RID_ = null;
            let CID_ = null;
            RID_ = GetValues("rid");
            CID_ = GetValues("cid");

            if (RID_ == undefined || !RID_) {
                RID_ = "";
            }
            if (CID_ == undefined || !CID_) {
                CID_ = "";
            }

            let message = form.recipients
                .map((item, index) => {
                    return `(${index + 1}) ${item.message}`;
                })
                .join("; ");

            const apiData = {
                First_name: form.sender_first_name,
                Last_name: form.sender_last_name,
                MobileNo: form.sender_mobile,
                EmailID: form.sender_email,
                TextBlock: "",
                Action_Note_Description: "",
                Action_Notes: message,
                formid: "46",
                dbId: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f",
                SourceURL: getsourceurl(),
                pagereferrerurl: getsourceurl(),
                rid: RID_,
                cid: CID_,
                pagetitle: getpagetitle(),
                Notsubmit: "no"
            };

            console.log("order", apiData);

            let formData = new FormData();

            formData = this.objectToFormData(apiData);

            fetch("https://resu.io/Subscription/IndexInsertAPITemp", {
                method: "post",
                body: formData
            }).then(function(response) {
                console.log("result", response);
                callback();
            });
        },
        // Function to add all object properties to FormData
        objectToFormData(obj, formData = new FormData(), parentKey = "") {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    // Append the value to FormData
                    formData.append(key, obj[key]);
                }
            }
            return formData;
        }
    },

    computed: {
        /**
         *
         * @returns Array
         */
        selectedWildCardImage() {
            return this.wild_cards.filter(card => {
                return card.id === this.form.wild_card_id;
            });
        },
        scheduledDate() {
            return moment(this.form.scheduled_date).format();
        },
        isScheduled() {
            return (
                moment().format("YYYYMMDD") !==
                moment(this.form.scheduled_date).format("YYYYMMDD")
            );
        }
    },

    mounted() {
        // Set scheduled date is not set default to current date
        let date = new Date();
        // date = new Date(
        //     date.toLocaleString("en-US", {
        //         timeZone: "Asia/Singapore"
        //     })
        // );

        if (this.occasion.scheduled_at) {
            let scheduled_date = new Date(this.occasion.scheduled_at);

            if (
                date.setHours(0, 0, 0, 0) > scheduled_date.setHours(0, 0, 0, 0)
            ) {
                //
                let year =
                    date.getFullYear() == scheduled_date.getFullYear()
                        ? date.getFullYear() + 1
                        : date.getFullYear();

                this.form.scheduled_date = new Date(
                    year,
                    scheduled_date.getMonth(),
                    scheduled_date.getDate()
                );
            } else {
                this.form.scheduled_date = scheduled_date;
            }
        } else {
            this.form.scheduled_date = date;
        }
    }
};
</script>

<style scoped>
.vc-w-full {
    width: auto;
}
.sender label,
.recipient label {
    display: none;
}
</style>
